module.exports = __webpack_public_path__ + "static/img/500.c6d6789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/500.png
// module id = 8zmr
// module chunks = 0